export default __webpack_public_path__ + "files/media/s-nysf.10acf916.jpg";